import { PlanFinding } from '@core/models/plan-finding.model';

import { normalize } from './warning-normalizer';

export interface OccurrenceCounts {
  total: number;
  blocking: number;
}

/**
 * Counted as the findings list shows them, one per occurrence: a finding may describe several
 * violations, and a `multiple_errors` one wraps others whatever their number.
 */
export function occurrenceCounts(findings: PlanFinding[]): OccurrenceCounts {
  let total = 0;
  let blocking = 0;
  for (const finding of findings) {
    const count = normalize(finding).length;
    total += count;
    if (finding.blocksOptimization) blocking += count;
  }
  return { total, blocking };
}
